<template>
  <div class="container-fluid">
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-lg-6 col-md-12">
        <div
          class="card single_post"
          v-for="(list, index) in listDetail"
          :key="index"
        >
          <blog-list
            :img_src="list.img_src"
            :title="list.title"
            :title_details="list.title_details"
            :btn_contain="list.btn_contain"
            :sub_details="list.status"
          ></blog-list>
        </div>
        <replay-form></replay-form>
      </div>

      <div class="col-lg-6 col-md-12">
        <new-post></new-post>
        <single-post></single-post>
      </div>
    </div>

    <div class="row clearfix">
      <div class="col-lg-8 col-md-12">
        <blog-comments></blog-comments>
      </div>
      <div class="col-lg-4 col-md-12">
        <categories-clouds></categories-clouds>
        <email-newsletter></email-newsletter>
      </div>
    </div>

    <div class="row clearfix">
      <div class="col-lg-4 col-md-12">
        <social-counter></social-counter>
        <instagram-post></instagram-post>
        <profile></profile>
      </div>
      <div class="col-lg-8 col-md-12">
        <search></search>
        <post-carousel></post-carousel>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "BlogComponent",
  components: {
    BreadCrumb: () => import("@/components/BreadCrumb.vue"),
    "blog-list": () => import("@/components/core/BlogLists.vue"),
    "replay-form": () => import("@/components/core/ReplyForm.vue"),
    "blog-comments": () => import("@/components/core/BlogComments.vue"),
    "categories-clouds": () => import("@/components/core/CategoriesClouds.vue"),
    "instagram-post": () => import("@/components/core/InstagramPost.vue"),
    "social-counter": () => import("@/components/core/SocialCounter.vue"),
    profile: () => import("@/components/core/Profile.vue"),
    "email-newsletter": () => import("@/components/core/EmailNewsletter.vue"),
    search: () => import("@/components/core/Search.vue"),
    "post-carousel": () => import("@/components/core/PostCarousel.vue"),
    "new-post": () => import("@/components/core/NewPost.vue"),
    "single-post": () => import("@/components/core/SinglePost.vue"),
  },
  data() {
    return {
      listDetail: [
        {
          img_src: require(`@/assets/blog/blog-page-1.jpg`),
          title: "All photographs are accurate",
          title_details:
            "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal",
          btn_contain: "Continue Reading",
          status: [
            {
              url: "javascript:void(0);",
              sub_title: "General",
            },
            {
              url: "javascript:void(0);",
              sub_title: "28",
            },
            {
              url: "javascript:void(0);",
              sub_title: "128",
            },
          ],
        },
      ],
    };
  },
};
</script>
